import { IDENTITY_ADDRESS_DIS, UNDECRYPTABLE_IDENTITY_DIS } from '@onefootprint/core';
import type { DataIdentifier, OnboardingRequirementCollectCustomData } from '@onefootprint/request-types';

export type CustomDisType = `custom.${string}` | Extract<DataIdentifier, `id.${string}`>;

const ADDRESS_SUB_FIELDS = ['country', 'address_line1', 'address_line2', 'city', 'state', 'zip'];

/**
 * The DIs to decrypt so the form can show the user their existing answers. A question collecting an
 * identity address contributes all six address DIs; a `custom.*` address contributes the same six
 * as suffixes of its prefix DI.
 */
export const getCustomDataDis = (
  collectCustomDataRequirement: OnboardingRequirementCollectCustomData,
): CustomDisType[] => {
  const dis: CustomDisType[] = [];

  for (const section of collectCustomDataRequirement.page.sections) {
    if (section.kind !== 'prompt') {
      continue;
    }

    const di = section.di;
    if (!di.startsWith('custom.') && !di.startsWith('id.')) {
      continue;
    }

    if (section.config.kind !== 'address') {
      dis.push(di as CustomDisType);
      continue;
    }

    if (di.startsWith('id.')) {
      dis.push(...(IDENTITY_ADDRESS_DIS as CustomDisType[]));
    } else {
      dis.push(...ADDRESS_SUB_FIELDS.map(field => `${di}_${field}` as CustomDisType));
    }
  }

  return dis.filter(di => !UNDECRYPTABLE_IDENTITY_DIS.includes(di));
};
